import { render, staticRenderFns } from "./MoAntBlueButton.vue?vue&type=template&id=9c9c4dda&scoped=true&"
import script from "./MoAntBlueButton.vue?vue&type=script&lang=js&"
export * from "./MoAntBlueButton.vue?vue&type=script&lang=js&"
import style0 from "./MoAntBlueButton.vue?vue&type=style&index=0&id=9c9c4dda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9c4dda",
  null
  
)

export default component.exports